import { render, staticRenderFns } from "./TicketPreview.vue?vue&type=template&id=36c7f018&scoped=true"
import script from "./TicketPreview.vue?vue&type=script&lang=ts"
export * from "./TicketPreview.vue?vue&type=script&lang=ts"
import style0 from "./TicketPreview.vue?vue&type=style&index=0&id=36c7f018&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c7f018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c7f018')) {
      api.createRecord('36c7f018', component.options)
    } else {
      api.reload('36c7f018', component.options)
    }
    module.hot.accept("./TicketPreview.vue?vue&type=template&id=36c7f018&scoped=true", function () {
      api.rerender('36c7f018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/TicketPreview.vue"
export default component.exports